export default "__VITE_ASSET__efa8f6e1__"